import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const getUserInspectorDownloadCsv = ( {data} : {data: IUserInspectorSearchForm}): Promise<string> => {
  return axiosDefaultApi.post(`api/UserInspector/getUserInspectorDowloadCSV`, data, header);
};

type QueryFnType = typeof getUserInspectorDownloadCsv;

type UseUserInspectorDownloadCsvOptions = {
  data: IUserInspectorSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useUserInspectorDownloadCsv = ({ config }: UseUserInspectorDownloadCsvOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου των κινήσεων.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading user inspector csv:', error);
    },
    onSuccess: () => {
      console.log('User Inspector csv downloaded successfully.');
    },
    ...config,
    mutationFn: getUserInspectorDownloadCsv,
  })
}